module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/430cfaacb53de690a0e51ca403c81aaf.png";